import { CheckCircle, Lightbulb, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";
const learningPoints = ["Leer tu reporte de crédito como un experto", "Entender por qué el score sube o baja", "Reconocer qué estrategias funcionan y cuáles no", "Evitar errores que cuestan años y miles de dólares"];
const benefits = ["Arreglar tu propio crédito con criterio", 'Evitar estafas de "reparación de crédito"', "Saber exactamente qué hacer antes de pedir tarjetas o préstamos", "Tomar mejores decisiones financieras", "Tener una base sólida de educación financiera real"];
const EducationSection = () => {
  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };
  return <section className="relative overflow-hidden section-padding bg-muted/30">
      {/* Background dots pattern - same as VideoSection */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.3) 1px, transparent 1px)`,
        backgroundSize: "20px 20px"
      }} />
      </div>

      <div className="container-centered relative z-10">
        <div className="max-w-3xl mx-auto">
          {/* Content Column - Shows second on mobile, first on desktop */}
          <div className="lg:order-1 text-center lg:text-left">
            {/* Section Badge */}
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 border border-primary/20 px-4 py-2">
              <BookOpen className="h-4 w-4 text-primary" />
              <span className="text-sm font-medium text-primary">Educación Financiera Real</span>
            </div>

            {/* Title */}
            <h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl lg:text-4xl">
              Esto No Es Solo Para{" "}
              <span className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent">
                Arreglar Tu Crédito
              </span>
            </h2>

            {/* Subtitle */}
            <p className="mt-4 text-lg font-semibold text-secondary-foreground">
              Aprendes cómo funciona el sistema de crédito en EE. UU. para tomar decisiones seguras toda la vida.
            </p>

            {/* Main Text */}
            <div className="mt-6 space-y-4 text-muted-foreground text-left">
              <p>La mayoría de personas solo quiere "arreglar su crédito" y ya.</p>
              <p>
                Pero quienes realmente logran estabilidad financiera hacen algo distinto:{" "}
                <span className="font-semibold text-secondary-foreground">
                  entienden cómo funciona el sistema de crédito en Estados Unidos.
                </span>
              </p>
              <p>
                <strong className="text-foreground">El Código del Crédito Perfecto</strong> no es solo una lista de
                pasos.
                <br />
                Es una guía que te enseña a:
              </p>
            </div>

            {/* Learning Points */}
            <ul className="mt-4 space-y-2 text-left">
              {learningPoints.map((point, index) => <li key={index} className="flex items-start gap-3">
                  <span className="mt-1 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 text-xs font-bold text-slate-900">
                    •
                  </span>
                  <span className="text-secondary-foreground">{point}</span>
                </li>)}
            </ul>

            {/* Transition Text */}
            <p className="mt-6 text-muted-foreground text-left">
              Cuando entiendes el sistema, <span className="font-semibold text-primary">el miedo desaparece...</span> y
              el control vuelve a tus manos.
            </p>

            {/* Benefits */}
            <div className="mt-8 text-left">
              <p className="font-semibold text-foreground mb-4">Este conocimiento te permite:</p>
              <ul className="space-y-3">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3">
                    <CheckCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-primary" />
                    <span className="font-medium text-secondary-foreground">{benefit}</span>
                  </li>)}
              </ul>
            </div>

            {/* Impact Quote */}
            <div className="mt-8 max-w-md mx-auto lg:mx-0 rounded-xl bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 border border-primary/20 p-4 sm:p-6 text-left">
              <div className="flex items-start gap-3">
                <Lightbulb className="h-6 w-6 flex-shrink-0 text-amber-400" />
                <p className="text-base sm:text-lg font-semibold text-foreground">
                  El crédito no es un secreto…
                  <br />
                  <span className="text-secondary-foreground font-normal">
                    solo que nunca nos lo explicaron de forma clara y en español.
                  </span>
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-8 text-center lg:text-left">
              <Button onClick={handleBuyClick} size="lg" className="h-auto min-h-14 w-full sm:w-auto bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 px-6 sm:px-12 py-3 text-sm sm:text-lg font-bold text-slate-900 shadow-lg transition-all hover:scale-105 hover:opacity-90 whitespace-normal text-center">
                <span>👉 QUIERO APRENDER EL SISTEMA – $16.99</span>
              </Button>
              <p className="mt-3 text-sm text-muted-foreground">⏳ Precio de lanzamiento por tiempo limitado Acceso inmediato • Garantía de 60 días • Sin riesgo</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default EducationSection;
